export const LOAD_BRP_SETTINGS = 'loadBRPSettings';
export const SAVE_BRP_SETTINGS = 'saveBRPSettings';
export const LOAD_PRP_SETTINGS = 'loadPRPSettings';
export const SAVE_PRP_SETTINGS = 'savePRPSettings';